import Routes from "integrations/aws/common/Routes";
import AWSCloudTrailRoutes from "integrations/aws/cloudtrail/common/Routes";
import AWSInputConfiguration from "./aws/AWSInputConfiguration";
import AWSCloudWatchApp from "./aws/cloudwatch/CloudWatchApp";
import EmbeddedCloudWatchApp from "./aws/cloudwatch/EmbeddedCloudWatchApp";
import CloudTrailInputConfiguration from "./aws/cloudtrail/CloudTrailInputConfiguration";
import EmbeddedCloudTrailApp from "./aws/cloudtrail/EmbeddedCloudTrailApp";
import AWSCloudTrailApp from "./aws/cloudtrail/CloudTrailApp";
import { defaultConfig as PagerDutyDefaultConfig } from "./pager-duty/PagerDutyConfig";
import PagerDutyNotificationDetails from "./pager-duty/PagerDutyNotificationDetails";
import PagerDutyNotificationForm from "./pager-duty/PagerDutyNotificationForm";
import PagerDutyNotificationSummary from "./pager-duty/PagerDutyNotificationSummary";
import SlackNotificationDetails from "./event-notifications/event-notification-details/SlackNotificationDetails";
import SlackNotificationForm from "./event-notifications/event-notification-types/SlackNotificationForm";
import SlackNotificationSummary from "./event-notifications/event-notification-types/SlackNotificationSummary";
import TeamsNotificationDetails from "./event-notifications/event-notification-details/TeamsNotificationDetails";
import TeamsNotificationForm from "./event-notifications/event-notification-types/TeamsNotificationForm";
import TeamsNotificationSummary from "./event-notifications/event-notification-types/TeamsNotificationSummary";
import GreyNoiseAdapterFieldSet from "./dataadapters/GreyNoiseAdapterFieldSet";
import GreyNoiseAdapterSummary from "./dataadapters/GreyNoiseAdapterSummary";
import GreyNoiseAdapterDocumentation from "./dataadapters/GreyNoiseAdapterDocumentation";
import TeamsNotificationV2Form from "./event-notifications/event-notification-types/TeamsNotificationV2Form";
import TeamsNotificationV2Summary from "./event-notifications/event-notification-types/TeamsNotificationV2Summary";
import TeamsNotificationV2Details from "./event-notifications/event-notification-details/TeamsNotificationV2Details";
const bindings = {
  routes: [
    { path: Routes.unqualified.INTEGRATIONS.AWS.CLOUDWATCH.index, component: AWSCloudWatchApp },
    { path: AWSCloudTrailRoutes.unqualified.INTEGRATIONS.AWSCloudTrail.ACTIVITYAPI.index, component: AWSCloudTrailApp }
  ],
  inputConfiguration: [
    {
      type: "org.graylog.integrations.aws.inputs.AWSInput",
      component: AWSInputConfiguration,
      embeddedComponent: EmbeddedCloudWatchApp
    },
    {
      type: "org.graylog.aws.inputs.cloudtrail.CloudTrailInput",
      component: CloudTrailInputConfiguration,
      embeddedComponent: EmbeddedCloudTrailApp
    }
  ],
  eventNotificationTypes: [
    {
      type: "pagerduty-notification-v2",
      displayName: "PagerDuty Notification [Official]",
      formComponent: PagerDutyNotificationForm,
      summaryComponent: PagerDutyNotificationSummary,
      detailsComponent: PagerDutyNotificationDetails,
      defaultConfig: PagerDutyDefaultConfig
    },
    {
      type: "slack-notification-v1",
      displayName: "Slack Notification",
      formComponent: SlackNotificationForm,
      summaryComponent: SlackNotificationSummary,
      detailsComponent: SlackNotificationDetails,
      defaultConfig: SlackNotificationForm.defaultConfig
    },
    {
      type: "teams-notification-v1",
      displayName: "Microsoft Teams Notification (Deprecated - use V2)",
      formComponent: TeamsNotificationForm,
      summaryComponent: TeamsNotificationSummary,
      detailsComponent: TeamsNotificationDetails,
      defaultConfig: TeamsNotificationForm.defaultConfig
    },
    {
      type: "teams-notification-v2",
      displayName: "Microsoft Teams Notification V2",
      formComponent: TeamsNotificationV2Form,
      summaryComponent: TeamsNotificationV2Summary,
      detailsComponent: TeamsNotificationV2Details,
      defaultConfig: TeamsNotificationV2Form.defaultConfig
    }
  ],
  lookupTableAdapters: [
    {
      type: "GreyNoise",
      displayName: "GreyNoise Quick IP Lookup",
      formComponent: GreyNoiseAdapterFieldSet,
      summaryComponent: GreyNoiseAdapterSummary,
      documentationComponent: GreyNoiseAdapterDocumentation
    }
  ]
};
export default bindings;
